module.exports = __webpack_public_path__ + "img/triangle-01-back-01.db3d1896.svg";